import loadable from '@loadable/component';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/reducers';

import { ModalTypes } from 'Constants/modalTypes';

import LoadingSpinner from 'Components/loading/LoadingSpinner';
import CaughtErrorModal from 'Components/modal/CaughtErrorModal';
import ModalContainer from 'Components/modal/ModalContainer';
import ErrorBoundary from 'Components/utility/ErrorBoundary';

/*

  This is where all modals in the app are rendered from. Modal types are dynamically imported by
  React-Loadable on dispatching a modal action. The modal action itself contains the name of the component
  in the filestructure that contains the modal contents.

*/

const loadableModal = (modalType: ModalTypes) => {
  return loadable(() => import(`Components/modal/${modalType}`), {
    fallback: <LoadingSpinner />,
  });
};

const mapState = ({ modal }: RootState) => {
  return {
    modalProps: modal.modalProps,
    modalType: modal.modalType,
  };
};

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

const Modal: React.FC<React.PropsWithChildren<Props>> = ({ modalProps = {}, modalType }) => {
  if (!modalType) {
    return <ModalContainer />;
  }

  const { id = 'modal' } = modalProps;

  const ModalLoader = loadableModal(modalType);

  return (
    <ErrorBoundary key={id} FallbackComponent={CaughtErrorModal}>
      <ModalLoader {...modalProps} />
    </ErrorBoundary>
  );
};

export default connector(Modal);
